import * as signalR from '@microsoft/signalr';

/**
 * Hosts the rfIDEAS badge reader (`BadgeTap` event) and the HID DigitalPersona fingerprint reader
 * (`FingerprintCaptured` event). Centralized here so every consumer agrees on the URL.
 */
export const CLIENT_SERVICE_HUB_URL = 'http://localhost:7274/hub';

/** Shape of the `BadgeTap` event pushed by `BadgeReaderService` when a badge is presented. */
export interface BadgeTapEvent {
    cardDataHex?: string;
    /** Some serializers emit PascalCase; accept either. */
    CardDataHex?: string;
}

/**
 * Shape of the `FingerprintCaptured` event pushed by `FingerprintReaderService` when a finger is
 * placed on the reader. Carries the ISO/IEC 19794-2 FMD (Fingerprint Minutiae Data) template as
 * base64 — no raw fingerprint image is ever transmitted (BIPA + Ohio OAC 4729).
 */
export interface FingerprintCapturedEvent {
    templateBase64?: string;
    /** Some serializers emit PascalCase; accept either. */
    TemplateBase64?: string;
    format?: string;
    Format?: string;
    timestamp?: string;
    Timestamp?: string;
}

/**
 * Builds an unstarted connection to the local client-service hub.
 *
 * Callers register their `.on(...)` handlers before calling `start()` (so they don't miss the first
 * event after connection) and `stop()` the connection in their teardown path.
 */
export function buildClientServiceHub(): signalR.HubConnection {
    return new signalR.HubConnectionBuilder()
        .withUrl(CLIENT_SERVICE_HUB_URL)
        .build();
}
